module.exports = __webpack_public_path__ + "img/diamonds-2x.f4c165a1.png";